import React, { useCallback, useContext, useMemo } from "react"
import SKLand from "@skland/one-bridge"
import classNames from "classnames"
import { SafeAreaView } from "@hg/layouts"
import { useShowRoleSelect } from "@hg/one-account"

import { useETL, useTranslation } from "@/locales"
import { getRogue5SpecialUrl } from "@/utils/misc"
import { webLogin } from "@/utils/sdk"
import { ESubPage, GlobalContext } from "../../context"

import styles from "./index.module.less"

interface IProps {
    page: ESubPage
    className?: string
    style?: React.CSSProperties
}

const pages = Object.values(ESubPage)

const Nav: React.FC<IProps> = (props) => {
    const { page, className, style } = props
    const { t } = useTranslation()
    const {
        state: { user, hasRole },
        dispatch,
    } = useContext(GlobalContext)

    const showRoleSelect = useShowRoleSelect()
    const collect = useETL()
    const handleClick = useCallback(
        async (key: ESubPage) => {
            collect("button_click", { button_name: `nav_${key}` })
            if (!__ROGUE_5_PRE) {
                if (key === ESubPage.SP) {
                    window.open(getRogue5SpecialUrl())
                    return
                }
            }

            // 数据模块和游戏模块需要登陆
            if ([ESubPage.Record, ESubPage.Game].includes(key) && !user) {
                const loginResult = await webLogin(dispatch)
                if (!loginResult) {
                    return
                }
                dispatch({
                    type: "updateContext",
                    payload: { currentSubPage: key },
                })
                return
            }

            dispatch({
                type: "updateContext",
                payload: { currentSubPage: key },
            })
        },
        [dispatch, hasRole, showRoleSelect, user]
    )

    const rest = useMemo(() => {
        return pages.reduce<
            {
                key: ESubPage
                main: string
                sub: string
            }[]
        >((acc, cur) => {
            if (cur !== page) {
                acc.push({
                    key: cur,
                    main: `“${t(`subPage.${cur}`)}”`,
                    sub: t(`subPage.${cur}.sub`).split(" ").join("   "),
                })
            }

            return acc
        }, [])
    }, [page, t])

    return (
        <SafeAreaView
            mode="margin"
            edges={["left"]}
            className={classNames(styles.nav, className)}
            style={style}
        >
            <div className={styles.current}>
                <div className={styles.bg}>
                    <div className={styles.ray} />
                    <div className={styles.rect} />
                    <div className={styles.fire} />
                </div>
                <div className={styles.text}>
                    <div className={styles.main}>{t(`subPage.${page}`)}</div>
                    <div className={styles.sub}>
                        {t(`subPage.${page}.sub`).split(" ").join("   ")}
                    </div>
                </div>
            </div>
            <div className={styles.rest}>
                {rest.map((item) => (
                    <div
                        key={item.key}
                        className={styles.item}
                        onClick={() => handleClick(item.key)}
                    >
                        <div className={styles.main}>{item.main}</div>
                        <div className={styles.sub}>{item.sub}</div>
                    </div>
                ))}
            </div>
        </SafeAreaView>
    )
}

export default Nav
